/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `CALL` - Odchozí volání
 *   * `CALLBACK` - Příchozí volání
 *   * `JOB` - Změna stavu jobu
 *   * `FLOW` - Krok workflow
 *   * `LEGACY` - Přenesený řádek
 * ```
 */
export const EventTypeEnum = {
  CALL: 'CALL',
  CALLBACK: 'CALLBACK',
  JOB: 'JOB',
  FLOW: 'FLOW',
  LEGACY: 'LEGACY',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type EventTypeEnum = ValuesOf<typeof EventTypeEnum>;

export type EventTypeEnumRequest = EventTypeEnum;
export type EventTypeEnumResponse = EventTypeEnum;
